import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class CategoryBreadcrumb extends Component {
	static propTypes = {
		category: PropTypes.object,
		breadcrumbs: PropTypes.array,
	};

	render() {
		const { category, breadcrumbs } = this.props;
		
		return (
			<div className="breadcrumb-section">
				<div className="container">
					<div className="row">
						<div className="col-sm-6">
							<div className="page-title">
								<h2>{category.name}</h2>
							</div>
						</div>
						<div className="col-sm-12 col-md-12 col-lg-6">
							<nav aria-label="breadcrumb" className="theme-breadcrumb">
								<ol className="breadcrumb">
									{breadcrumbs
										? breadcrumbs.map((item, i) => {
											let url = '';
											for (let j = 1; j <= i; j++) {
												const valueToInject = breadcrumbs[j].name === 'Hybrid or Electric' ? 'hybrid-electric' : breadcrumbs[j].name;
												url += valueToInject.replace(/\./g,'-').toLowerCase() + '-';
											}
											url = url.replace(/\s/g,'-').slice(0, -1);
											return (
												<li className="breadcrumb-item" key={i}>
													<Link
														href={
															item.id == 0
																? `/` // Leave as ID...  URL Slug is dependent in the dataset and not pre-generated yet
																: '/category/[category]'
														}
														as={
															item.id == 0
																? `/` // Leave as ID...  URL Slug is dependent in the dataset and not pre-generated yet
																: `/category/${url}`
														}
														prefetch={false}>
														<a>{item.name}</a>
													</Link>
												</li>
											)
										})
										: category.name}
								</ol>
							</nav>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default CategoryBreadcrumb;
